import React, { useState } from "react";
import "./Badges.scss";
import { Card, CardContent } from "@material-ui/core";
import { useSelector } from "react-redux";
import { Level, Badge } from "../ProgressDetailsInterfaces";
import DialogComponent from "../../../shared/DialogComponent/DialogComponent";
import translate from "../../../../i18n/translate";
import { getFirstLettersLowerCase } from "./utils";

interface BadgesProps {
  data: Badge;
  activeLevel: Level;
}
interface RootState {
  common: {
    productID: string;
  };
}

const Badges = (props: BadgesProps) => {
  const { hasBadge, badgePercent } = props.data;
  const { productID } = useSelector((state: RootState) => state.common);
  const [openDialog, setOpenDialog] = useState(false);

  const handleClose = () => {
    setOpenDialog(false);
  };

  const getAppropriateBadge = () => {
    let appropriateBadge: string = "";

    if (badgePercent >= 50 && badgePercent <= 69) {
      appropriateBadge = "Bronze";
      return appropriateBadge;
    }
    if (badgePercent >= 70 && badgePercent <= 79) {
      appropriateBadge = "Silver";
      return appropriateBadge;
    }
    if (badgePercent >= 80 && badgePercent <= 100) {
      appropriateBadge = "Gold";
      return appropriateBadge;
    }
  };

  const getBadgeImage = () => {
    let appropriateBadge = getAppropriateBadge();
    let badgeUrl: string =
      process.env["REACT_APP_ASSETS_URL"] +
      "/halo/badges/business-skills/sprint-bskills-ss-" +
      appropriateBadge?.charAt(0) +
      "-" +
      getFirstLettersLowerCase(props.activeLevel.title) +
      "-" +
      getFirstLettersLowerCase(props.activeLevel.level) +
      ".svg";

    return badgeUrl.toLowerCase();
  };

  return (
    <>
      <div className="badge-container">
        <Card className="completion-card no-shadow general-clickable" onClick={() => setOpenDialog(true)}>
          <CardContent className="completion-card-body">
            <div>
              {!hasBadge && (
                <img
                  alt="badge-placeholder"
                  src={"../../../images/badge/badge-placeholder.svg"}
                  className={"badge-placeholder"}
                />
              )}
              {hasBadge && <img alt="overall-badge" src={getBadgeImage()} className={"overall-badge"} />}
              {!hasBadge && (
                <img
                  onKeyDown={() => {}}
                  alt="cert-badge-lock"
                  src={"../../../images/cert-badge-lock.svg"}
                  className={"lock-icon"}
                  data-testid="completion-card-Id"
                  onClick={() => setOpenDialog(true)}
                />
              )}
            </div>
          </CardContent>
        </Card>
      </div>
      {openDialog && (
        <DialogComponent
          openDialog={openDialog}
          title={""}
          handleClose={handleClose}
          
          perPartBadgePercentage={badgePercent}
        >
          <h6>{translate("progress_overall_card_title_certificate")}:</h6>
          <p>{translate("progress_badge_dialog_box_title")}</p>
          {productID !== "25" && (
            <>
              <h6>{translate("progress_overall_card_title_badge")}:</h6>
              <ul>
                <li>{translate("progress_badge_dialog_box_golden")}</li>
                <li>{translate("progress_badge_dialog_box_silver")}</li>
                <li>{translate("progress_badge_dialog_box_bronze")}</li>
              </ul>
            </>
          )}
          <p>
            {(productID === "21" || productID === "22" || productID === "23" || productID === "24") && (
              <>*{translate("progerss_badge_dailog_box_digitalActivities")}.</>
            )}
            {(productID == "20" ||
              productID == "18" ||
              productID == "26" ||
              productID == "27" ||
              productID == "28" ||
              productID == "29") && <>*{translate("progress_badge_dailog_box_liveSessions")}.</>}
            {productID == "25" && <>{translate("progress_elevate_dialog_box_liveSessions")}.</>}
          </p>
        </DialogComponent>
      )}
    </>
  );
};

export default Badges;
